import { useQuery } from "@tanstack/react-query";
import { fetch3 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

export const useFetchOrderAllocationData = (
    page?: number,
    limit?: number,
    searchFor?: string
) => {
    return useQuery({
        queryKey: ["orderAllocationsData", page, limit, searchFor],
        queryFn: async () => {
            const res = await fetch3(
                `${url}/api/order-allocations-router?page=${page}&limit=${limit}&searchFor=${searchFor}`,
                "get"
            );

            if (!res || !res.data) {
                return res.message;
            }

            return res.data; // 👈 This returns your full user object
        },
        staleTime: 1000 * 60 * 5,
    });
};